// API配置
const API_CONFIG = {
  // 优先使用运行时配置，然后是环境变量，最后使用相对路径
  baseURL: (typeof window !== 'undefined' && window.ENV_CONFIG?.API_BASE_URL) ||
    process.env.VUE_APP_API_BASE_URL || 
    // 默认使用相对路径，通过nginx代理或开发服务器代理
    '',
  endpoints: {
    users: {
      statistics: '/api/users/statistics'
    },
    skins: {
      usage: '/api/skins/usage/counts',
      detailed: '/api/skins/statistics/detailed'
    },
    wallpapers: {
      list: '/api/wallpapers',
      upload: '/api/wallpapers/upload',
      delete: (id) => `/api/wallpapers/${id}`
    },
    announcements: {
      list: '/api/announcements',
      create: '/api/announcements',
      delete: (id) => `/api/announcements/${id}`
    },
    messages: {
      list: '/api/messages/broadcast',
      create: '/api/messages/broadcast',
      delete: (id) => `/api/messages/broadcast/${id}`
    },
    oss: {
      stsToken: '/api/oss/sts-token'
    }
  }
}

// 创建完整的API URL
export const createApiUrl = (endpoint) => {
  return `${API_CONFIG.baseURL}${endpoint}`
}

// 创建请求选项（包含认证头）
export const createRequestOptions = (options = {}) => {
  const token = localStorage.getItem('admin_token')
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` })
    }
  }
  
  return {
    ...defaultOptions,
    ...options,
    headers: {
      ...defaultOptions.headers,
      ...options.headers
    }
  }
}

// 导出API配置
export { API_CONFIG }
export default API_CONFIG 